module.exports = __webpack_public_path__ + "static/elder-brain-alt-mtg_clb-b1e3c028b5f8926189b3ef673c9efbac.jpg";